import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { StatementsRepository } from '../repositories/statements_repository/statements_repository';

export const fetchStatements = createAsyncThunk('statements/fetch', async (siteIds, { rejectWithValue }) => {
  try {
    const statements = await StatementsRepository.getStatements(siteIds);
    return statements;

  } catch (error) {
    console.error('Error fetching statements:', error);
    return rejectWithValue(error);
  }
});

const initialState = {
  statements: null,
  isLoading: false,
  error: null,
};

const statementsSlice = createSlice({
  name: 'statements',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStatements.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchStatements.fulfilled, (state, action) => {
      state.statements = action?.payload ?? [];
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(fetchStatements.rejected, (state, action) => {
      console.log(action.error.message ?? 'Something went wrong.');
      state.isLoading = false;
      state.error = action.error.message ?? 'Something went wrong.';
    });
  },
});

export default statementsSlice.reducer;
